






















import Vue, { PropType } from 'vue';
import Component, { mixins } from 'vue-class-component';

import { Link } from '@/types';

const Props = Vue.extend({
	props: {
		title: {
			type: String,
			default: undefined
		},
		links: {
			type: Array as PropType<Link[]>,
			required: true
		}
	}
});

const MixinsDeclaration = mixins(Props);

/** Displays a list of links */
@Component
export default class Links extends MixinsDeclaration {}
